(function () {
    var buttons = document.querySelectorAll('.share-copy-btn');

    buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var url = btn.getAttribute('data-url');
            if (!url) return;

            navigator.clipboard.writeText(url).then(function () {
                btn.classList.add('share-copy-btn--copied');
                var originalTitle = btn.getAttribute('title');
                btn.setAttribute('title', 'Скопировано!');

                setTimeout(function () {
                    btn.classList.remove('share-copy-btn--copied');
                    btn.setAttribute('title', originalTitle);
                }, 2000);
            });
        });
    });
})();
